import LoyaltyTierIcon from 'components/Luxkit/Icons/loyalty/LoyaltyTierIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import React, { ComponentProps, PropsWithChildren } from 'react'

export interface BaseLoyaltyPointsListItemProps {
  tier: App.LoyaltyTier
  size: 'S' | 'M'
}

type InheritedBodyTextProps = Pick<ComponentProps<typeof BodyText>, 'colour'>

interface Props extends BaseLoyaltyPointsListItemProps, InheritedBodyTextProps, PropsWithChildren {}

export const SIZES_BODY_TEXT_VARIANTS: Record<Props['size'], ComponentProps<typeof BodyText>['variant']> = {
  S: 'medium',
  M: 'large',
}

function LoyaltyPointsListItem({ children, tier, size, colour }: Props) {
  return <Group
    direction="horizontal"
    verticalAlign="center"
    gap={8}
  >
    <LoyaltyTierIcon tier={tier} size="S" />
    <BodyText variant={SIZES_BODY_TEXT_VARIANTS[size]} colour={colour}>{children}</BodyText>
  </Group>
}

export default LoyaltyPointsListItem
